<template>
  <div
    class="agf--flow-pages-wrapper"
    :class="{ 'agf--flow-pages-wrapper--completed': alreadyCompleted }"
  >
    <div
      v-for="(p, index) in $afs.flowPageFlattenedArrayWithVariables"
      class="agf--flow-pages-wrapper--inner"
      :class="{
        'agf--flow-pages-wrapper--inner--past': index < $afs.currentPageIndex,
        'agf--flow-pages-wrapper--inner--active': index === $afs.currentPageIndex,
        'agf--flow-pages-wrapper--inner--prev': index < $afs.currentPageIndex,
        'agf--flow-pages-wrapper--inner--next': index > $afs.currentPageIndex,
      }"
    >
      <FlowPage
        :flow-page="p.flowPage"
        :flow-variables="p.flowVariables"
        :page-index="index"
        @back="() => goBack()"
        @next="() => toNext()"
        :back-disabled="index === 0"
        :next-disabled="false"
      />
      <div v-if="alreadyCompleted" class="agf--flow-pages-wrapper--completed-note">
        ※ 同意済みの内容を表示中 (同意日時:
        {{ $core.$dayjs($afs.agreementRequest?.completed_at).format('YYYY/MM/DD HH:mm') }}
        )
      </div>
    </div>
    <div
      class="agf--flow-pages-wrapper--inner agf--flow-pages-wrapper--inner--active"
      v-if="isSubmitModalOpen && !hasSubmitCompleted"
    >
      <div class="agf--flow-page agf--flow-page--displayType-modal">
        <div class="agf--flow-page--header">確認</div>
        <div class="agf--flow-page--body">
          <div class="text-center">
            書類の内容に同意して<br />
            確認を完了してもよろしいですか
          </div>
        </div>
        <div class="agf--flow-page--footer">
          <button class="back" @click="() => goBack()">キャンセル</button>
          <button class="next " @click="() => runSubmit()">
            同意して確認完了
            <span class="agf--flow-page--footer--next-button-note"
              >完了通知メールを<br />メールアドレス宛に送信します</span
            >
          </button>
        </div>
      </div>
    </div>
    <div
      class="agf--flow-pages-wrapper--inner agf--flow-pages-wrapper--inner--active"
      v-if="hasSubmitCompleted"
    >
      <div class="agf--flow-page agf--flow-page--displayType-card">
        <div class="agf--flow-page--header">署名完了</div>
        <div class="agf--flow-page--body">
          署名が完了しました。<br/>
          <span v-if="$afs.agreementRequest?.send_method === 'メール'">署名いただいた内容はメールからご確認いただけますので、メールボックスをご確認ください。</span>
          <span v-else>署名いただいた内容は先ほどクリックしていただいたURLからご確認いただけます。</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import './AgreementFlow.scss'
import { AgreementFlowService } from './AgreementFlowService'
import FlowPage from './FlowPage.vue'

export default {
  name: 'FlowPagesWrapper',
  components: { FlowPage },
  inject: ['AgreementFlowService'],
  props: {
    shouldPreviewAsPrint: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isSubmitModalOpen: false,
    }
  },
  computed: {
    $afs(): AgreementFlowService {
      return this.AgreementFlowService as AgreementFlowService
    },
    hasSubmitCompleted(): boolean {
      return this.$afs.uiState === 'submit-completed'
    },
    alreadyCompleted(): boolean {
      return !!this.$afs.agreementRequest?.completed_at
    },
  },
  methods: {
    goBack() {
      if (this.isSubmitModalOpen) {
        this.isSubmitModalOpen = false
        return
      }
      this.$afs.currentPageIndex = this.$afs.currentPageIndex - 1
    },
    toNext() {
      if (this.$afs.isLastPage) {
        this.isSubmitModalOpen = true
        return
      }
      this.$afs.currentPageIndex = this.$afs.currentPageIndex + 1
    },
    async runSubmit() {
      this.$afs.runSubmit()
    },
  },
}
</script>
